// Wire types and URL helpers for the apps published to a project.

const { VITE_ANALYSIS_AGENT_API, VITE_PROJECTS_API } = import.meta.env;

export interface PublishedAppSummary {
  id: string;
  project_id: string;
  slug: string;
  title: string;
  summary: string | null;
  published_by: string;
  published_at: string;
}

export interface PublishedApp extends PublishedAppSummary {
  // The agent the app calls its tools as, and a copilot session starts with.
  agent_id: string | null;
}

export interface EditSession {
  conversation_id: string;
  template_artifact_id: string;
}

export const projectAppsPath = (projectId: string) =>
  `${VITE_PROJECTS_API}/projects/${projectId}/apps`;

export const projectAppPath = (projectId: string, slug: string) =>
  `${VITE_PROJECTS_API}/projects/${projectId}/apps/${slug}`;

// The caller's own session with a published app, created unlisted on first use.
export interface AppSession {
  id: string;
  listed: boolean;
}

export const appSessionPath = (projectId: string, slug: string) =>
  `${VITE_PROJECTS_API}/projects/${projectId}/apps/${slug}/session`;

export const publishAppPath = (conversationId: string, appName: string) =>
  `${VITE_ANALYSIS_AGENT_API}/conversations/${conversationId}/apps/${encodeURIComponent(appName)}/publish`;

export const appEditSessionPath = (projectId: string, slug: string) =>
  `${VITE_ANALYSIS_AGENT_API}/projects/${projectId}/apps/${slug}/edit-session`;
